import { createTheme } from "@mui/material/styles";
import { Theme } from "common";

const ROOT_BACKGROUND_COLOR = "#F6F6F6";
const STANFORD_ACCENT_BLUE = "#009ABB";
const STANFORD_TEXT_GRAY = "#333333";
const WHITE = "#FFFFFF";

export const MedActionsTheme = createTheme(Theme, {
  palette: {
    background: {
      default: ROOT_BACKGROUND_COLOR,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: "17px",
        },
        containedPrimary: {
          color: WHITE,
          "&:hover": {
            backgroundColor: STANFORD_ACCENT_BLUE,
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        subtitle1: {
          color: STANFORD_TEXT_GRAY,
          fontWeight: 500,
        },
      },
    },
    MuiIcon: {
      styleOverrides: {
        colorPrimary: {
          color: STANFORD_ACCENT_BLUE,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: STANFORD_TEXT_GRAY,
        },
      },
    },
  },
});
